import React from 'react'
import PropTypes from 'prop-types'
import { AccordionWithArrow } from '../../../../components'
import { Text, TextWrapper } from './style'
const ContentSection2 = ({ data }) => {
  return (
    <AccordionWithArrow title='Admin Control' expanded={true}>
      <TextWrapper>
        <Text primary="Item Id:" secondary={data.AggregationItem.AggregationItemId} />
        <Text primary="Analyzed By:" secondary={data.AggregationItem.CheckedBy} />
        <Text primary="QC By:" secondary={data.AggregationItem.QCBy} />
        <Text primary="Edited By:" secondary={data.AggregationItem.EditedBy} />
        <Text primary="Reanalyzed By:" secondary={data.AggregationItem.RecheckedBy} />
        <Text primary="Last Activity:" secondary={(data.AggregationItem.ModifiedDate).replace('T', ' ')} />
      </TextWrapper>
    </AccordionWithArrow>
  )
}

ContentSection2.propTypes = {
  data: PropTypes.object
}

export default ContentSection2
